import type { TypographyProps } from 'palette/Typography';
import { TLabelType } from '../types';

type ILabelTypes = {
    [K in TLabelType]: TypographyProps
};

export const labelTypes: ILabelTypes = {
    default: {
        weight: 'regular',
    },
    'small-title': {
        type: 'header',
        level: '6',
    },
    'large-title': {
        type: 'header',
        level: '5',
    },
};
